module.exports = __webpack_public_path__ + "static/media/Agri-investors_Needs_27-12-2023_-removebg-preview.1e6912fd.png";